import Vue from "vue";
import Vuex from "vuex";
import VuexPersistence from "vuex-persist";
Vue.use(Vuex);
const vuexLocal = new VuexPersistence({
    storage: window.localStorage
});
export default new Vuex.Store({
    state: {
        visitID: null,
        visit: null,
        feedback: false
    },
    mutations: {
        changeID(state, visitID) {
            state.visitID = visitID;
        },
        newVisit(state, visit) {
            state.visit = visit;
        },
        sentFeedback(state, isFeedbackSent) {
            state.feedback = isFeedbackSent;
        }
    },
    getters: {
        visitID: state => state.visitID,
        visit: state => state.visit,
        feedback: state => state.feedback
    },
    plugins: [vuexLocal.plugin]
});
